import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--midnight)] py-24 md:py-32" data-id="element-257">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto px-6" data-id="element-258">
        <div className="space-y-8 text-[var(--cream)]" data-id="element-259">
          <h2 className="font-display text-4xl md:text-5xl italic text-[var(--warm-gold)]" data-id="element-260">
            ¿Has Intentado Salir?
          </h2>

          <div className="h-px w-24 bg-[var(--warm-gold)]" data-id="element-261" />

          <div className="space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-262">
            <p data-id="element-263">Claro que sí. Porque tú no eres alguien que se rinde fácil.</p>

            <p data-id="element-264">
              Has leído libros de autoayuda. Has ido a la iglesia, has orado,
              has prometido a Dios que esta vez sí vas a cambiar. Has intentado
              "pensar positivo." Has hablado con amigos. Quizás hasta fuiste a
              terapia.
            </p>

            <p className="text-[var(--cream)]/90" data-id="element-265">
              Y algo funcionó... por un tiempo.
            </p>

            <p className="text-xl font-semibold text-[var(--sunset-coral)]" data-id="element-266">
              Pero luego volviste. Al mismo patrón. A la misma oscuridad. A la
              misma versión de ti que creías haber dejado atrás.
            </p>

            <p data-id="element-267">Y eso — volver — duele más que la primera caída.</p>

            <p className="italic text-[var(--cream)]/80" data-id="element-268">
              Porque ahora no solo cargas el dolor original. Cargas la culpa de
              no haberlo superado todavía.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}